export function isDeliveryNoteReadyStatus(status: string | null | undefined): boolean {
  return status === 'delivered' || status === 'completed'
}

export function shouldShowLegacyDrawerActions(status: string | null | undefined): boolean {
  return !isDeliveryNoteReadyStatus(status)
}

export function shouldShowDeliveryNoteAction(
  status: string | null | undefined,
  hasHandler: boolean
): boolean {
  return hasHandler && isDeliveryNoteReadyStatus(status)
}

export function shouldShowJoinQueueAction(
  status: string | null | undefined,
  tenantAllows: boolean,
  hasHandler: boolean
): boolean {
  return tenantAllows && hasHandler && (status === 'pending' || status === 'processing')
}
